import { useState, useRef, useEffect } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { socialService } from '../services/api'
import { useNotifications } from '../contexts/NotificationContext'
import Lottie from './Lottie'
import './RepostModal.css'

function RepostModal({ post, isOpen, onClose, onSuccess }) {
  const [content, setContent] = useState('')
  const [sendAnimation, setSendAnimation] = useState(null)
  const sendLottieRef = useRef(null)
  const { addNotification } = useNotifications()
  const queryClient = useQueryClient()

  useEffect(() => {
    if (isOpen) {
      setContent('')
    }
  }, [isOpen])

  useEffect(() => {
    fetch('/Send.json')
      .then(res => res.json())
      .then(data => setSendAnimation(data))
      .catch(err => console.error('Erreur chargement animation Send:', err))
  }, [])

  const repostMutation = useMutation({
    mutationFn: (repostContent) => socialService.repostPost(post.id, repostContent || null),
    onSuccess: (response) => {
      queryClient.invalidateQueries(['social-feed'])
      if (onSuccess) onSuccess()
      onClose()
      // Ne pas afficher de notification, l'animation sera gérée par PostCard
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.detail || 'Erreur lors du repost'
      addNotification({
        type: 'error',
        title: 'Repost impossible',
        message: errorMessage,
      })
      console.error('Erreur repost:', error)
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    const trimmedContent = content.trim()
    
    // Jouer l'animation Send
    if (sendLottieRef.current) {
      sendLottieRef.current.goToAndPlay(0)
    }

    repostMutation.mutate(trimmedContent || null)
  }

  if (!isOpen) return null

  return (
    <div className="repost-modal-overlay" onClick={onClose}>
      <div className="repost-modal" onClick={(e) => e.stopPropagation()}>
        <div className="repost-modal-header">
          <h3>Reposter</h3>
          <button className="repost-modal-close" onClick={onClose}>✕</button>
        </div>
        
        <div className="repost-modal-content">
          <textarea
            className="repost-textarea"
            placeholder="Ajoutez un commentaire (optionnel)..."
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={4}
            maxLength={500}
          />
          <div className="repost-char-count">{content.length}/500</div>
        </div>

        <div className="repost-modal-footer">
          <button
            className="repost-cancel-btn"
            onClick={onClose}
            disabled={repostMutation.isLoading}
          >
            Annuler
          </button>
          <button
            className="repost-submit-btn"
            onClick={handleSubmit}
            disabled={repostMutation.isLoading}
          >
            {repostMutation.isLoading ? (
              'Repost en cours...'
            ) : sendAnimation ? (
              <Lottie
                lottieRef={sendLottieRef}
                animationData={sendAnimation}
                loop={false}
                autoplay={false}
                style={{ width: 20, height: 20 }}
              />
            ) : (
              'Reposter'
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default RepostModal

